import React, { Component } from 'react';

// Importe de paquetes
import _ from 'lodash';
import { CSVLink } from 'react-csv';

// Importe de módulos
import Map from './Map.jsx';
import Shp from './Shp.js';
import XDialog from './XDialog.jsx';

// Importe css
import './css/CentralFert.css';

// Importe de funciones
import { abrev, convert_to_kgha, conv_to_decimeters, dap, fail, find_lyr_in, in_range, is_nitrogeno, NO3_to_N, noop, promedios, remove_parens, snum, takeDir, takeFilename, title_culti } from './utils.js';
import { fetch_unit_inv_lyr, get_culti_of_dir, get_ms_of_dir } from './fetch_things.js';
import { preload_escalas } from './make_book_util.js';
import { load_stats } from './show_stats.js';

// Importe de imágenes
const iconCulti   = require('./css/img/central_fert/rdto_esperado.png'),
      iconEspecie = require('./css/img/central_fert/especie.png'),
      iconRdto    = require('./css/img/central_fert/rdto_esperado.png');

export default class CentralFert extends Component {
  n_is_mineral;
  dem_sum_has;

  
  constructor(props) {
    super(props);
    
    this.state = {
      culti: '',
      cultis: [],
      elementos: [],
      especie: '',
      especies: [],
      especies_nm: [],
      especies_ids: [],
      especie_data: {
        dem_min_n:    0,
        dem_max_n:    0,
        dem_min_p2o5: 0,
        dem_max_p2o5: 0,
        dem_min_k2o:  0,
        dem_max_k2o:  0,
        dem_min_so3:  0,
        dem_max_so3:  0,
        dem_min_b:    0,
        dem_max_b:    0,
        dem_min_cao:  0,
        dem_max_cao:  0,
        dem_min_mgo:  0,
        dem_max_mgo:  0,
        dem_min_zn:   0,
        dem_max_zn:   0,
        rdto_min:     0,
        rdto_max:     0,
        rin:          0,
        rip:          0,
        rik:          0,
        ri_s:         0,
        ri_b:         0,
        ri_ca:        0,
        ri_mg:        0,
        ri_zn:        0,
        u_rdto:      ''
      },
      stats: {
        arr_ph:     [],
        arr_mo:     [],
        arr_n:      [],
        arr_p:      [],
        arr_k:      [],
        arr_s:      [],
        arr_b:      [],
        arr_ca:     [],
        arr_mg:     [],
        arr_zn:     [],
        inv_mo:  false,
        inv_s:   false,
        inv_b:   false,
        inv_ca:  false,
        inv_mg:  false,
        inv_zn:  false,
        unit_mo:    '',
        unit_n:     '',
        unit_p:     '',
        unit_k:     '',
        unit_s:     '',
        unit_b:     '',
        unit_ca:    '',
        unit_mg:    '',
        unit_zn:    '',
      },
      show_table: false,
      pols: [],
      rdto: 0,
      rdto_inrange: true
    };

    // Se guardan los Props y State de CentralFert para que se puedan usar en otros módulos
    props.app.central_fert = this;
    this.select_culti = this.select_culti.bind(this);
  }
  
  componentDidMount = () => {
    const { app } = this.props,
          { toolbar, map_ui } = this.props.app;

    if (app.toolbar) {
      const culti = toolbar.state.culti,   // Ruta de cultivable seleccionado
            cultis = toolbar.props.cultis; // Rutas de todos los cultivables seleccionados

      // Se define el estado de cultivables
      this.setState({ culti, cultis });

      // Se define la profundidad del suelo
      get_ms_of_dir(app, takeDir(culti), result => {
        preload_escalas(app, takeDir(culti), escs => {
          let prof = -1,
              prof_known = false;

          if (typeof(result) !== 'string') {
            const shp = result,
                  profs = _.uniq(_.map(shp.dbfRecords, 'PROF'));

            if (profs.length > 0 && typeof(profs[0]) === 'number') {
              prof = conv_to_decimeters(profs[0]);
              prof_known = true;
            }

            prof = conv_to_decimeters(30) // Si no tiene la profundidad, se asumen 30 cm
            prof_known = true;
          }

          this.setState({ prof, prof_known }, () => this.read_stats(app, escs, culti));
        });
      });

      // Se obtiene la listas de especies
      this.get_especies(especies_db => {
        // Especies de los predios en el cultivable seleccionado
        const especies_culti = _.uniq(
          _.chain(
            _.compact(map_ui.map.Shp_List[culti].obj.dbfRecords.map(esp =>
              _.has(esp, 'ESPECIE') && esp.ESPECIE !== 'NULL' ? esp.ESPECIE : null 
            )).map(e => e.toLowerCase())
          ).split(',').value()
        );

        // Especies con el nombre adecuado (tildes y eñes) (unicas) desde la DB
        const especies_filter = _.uniq(_.compact(especies_db.map(esp => esp.especie)));

        // Nombre alternativo de especies (para reconocerlos según lo que se haya escrito en gdb)
        const especies_filter_alt = _.uniq(_.compact(especies_db.map(esp => _.compact(_.split(esp.especie_alt, ',')))));

        // Se busca la intersección entre especies_filter, especies_filter_alt y especies_culti
        const especies = _.chain(especies_filter).concat(_.flatten(especies_filter_alt)).intersection(especies_culti).value().sort();

        const especies_nm = especies.map(esp => especies_db.find(obj => obj.especie_alt.includes(esp)));

        this.setState({ especies, especies_nm }, () => {
          // Se cargan los IDs de los predios según las especies
          const { especies } = this.state;

          const especies_ids = especies.map(esp => {
            let ids_especie = {
              ESPECIE: esp,
              HECTAREAS: [],
              IDS:       [],
              NOMBRE:    []
            };

            for (const r of map_ui.map.Shp_List[culti].obj.dbfRecords) {
              if (_.includes(r.ESPECIE.toLowerCase(), esp)) {
                ids_especie.HECTAREAS.push(typeof(r.HECTAREAS) !== 'number' ? parseFloat(r.HECTAREAS) : r.HECTAREAS);
                ids_especie.IDS.push(r.ID - 1); // Los IDs en los predios comienzan en 1, para iterarlos se le resta 1
                ids_especie.NOMBRE.push(typeof(r.NOMBRE) !== 'string' ? parseFloat(r.NOMBRE) : r.NOMBRE);
              }
            }

            return ids_especie;
          });

          this.setState({ especies_ids });
        });
      });

      // Marcar etiquetas al abrir la central
      if (map_ui.state.tag_hl !== null) {
        _.keys(map_ui.map.Shp_List).forEach(path => {
          if (path !== culti) {
            map_ui.setState({ tag_hl: null }, () => {
              map_ui.map.Shp_List[path].un_labelize();
            });
          } else {
            map_ui.setState({ tag_hl: this.props.tag_hl }, () => {
              map_ui.map.Shp_List[path].labelize_cf(this.props.tag_hl)
            });
          }
        });
      } else {
        map_ui.setState({ tag_hl: this.props.tag_hl }, () => {
          map_ui.map.Shp_List[culti].labelize_cf(this.props.tag_hl);
        });
      }
    }
  };

  componentWillUnmount = () => {
    const { map_ui } = this.props.app;

    this.props.app.central_fert = null;
    this.props.app.setState({ show_central_fert: false });

    // Quita las etiquetas de los cultivables
    map_ui.setState({ tag_hl: null }, () => {
      _.keys(map_ui.map.Shp_List).forEach(path => {
        map_ui.map.Shp_List[path].un_labelize();
      });
    });

    if (this.state.pols.length !== 0) {
      this.destroy_pols(this.state.pols, () => {});
    }
  };

  // Borra los polígonos de las especies que se seleccionan
  destroy_pols = (pols, next) => {
    pols.forEach(pol => {
      pol.setMap(null);
      pol = null;
    });
    
    return next(true);
  };

  // Obtiene sólo las columnas especie, alt_nom, lvl_ph de la tabla cf_especies
  get_especies = (next) => {
    const { app } = this.props,
            url   = `${app.remote}/get-especies/?session_id=${app.session()}`;

    fetch(url)
      .then(resp => resp.json())
      .then(data => next(data))
      .catch(err => console.log(err));
  };

  // Obtiene la fila completa del especie seleccionada
  get_especie = (especie, next) => {
    const { app } = this.props,
            url   = `${app.remote}/get-especie/?session_id=${app.session()}&especie=${especie}`;

    fetch(url)
      .then(resp => resp.json())
      .then(data => next(data))
      .catch(err => console.log(err))
  };

  // Obtiene los stats de los png asociados al cultivable seleccionado
  read_stats = (app, escs) => {
    if (app.toolbar) {
      let stats = {
        arr_ph : [],
        arr_mo : [],
        arr_n  : [],
        arr_p  : [],
        arr_k  : [],
        arr_ca : [],
        arr_s  : [],
        arr_mg : [],
        arr_b  : [],
        arr_zn : [],
        inv_mo : false,
        inv_ca : false,
        inv_s  : false,
        inv_mg : false,
        inv_b  : false,
        inv_zn : false,
        unit_mo: '',
        unit_n : '',
        unit_p : '',
        unit_k : '',
        unit_ca: '',
        unit_s : '',
        unit_mg: '',
        unit_b : '',
        unit_zn: ''
      };

      let path_lyr_mo = '',
          path_lyr_n : string = '',
          path_lyr_p : string = '',
          path_lyr_k : string = '',
          path_lyr_ca: string = '',
          path_lyr_s : string = '',
          path_lyr_mg: string = '',
          path_lyr_b : string = '',
          path_lyr_zn: string = '';

      this.n_is_mineral = false;

      for (const st of app.toolbar.all_stats) {
        let el = st.elem.toLowerCase();

        const ES_NITRO = is_nitrogeno(el);

        if (el.indexOf('-') !== -1) {
          el = el.split('-')[0];
        }

        if      (el === 'ph' ) {                                          stats.arr_ph = promedios(st);               }
        else if (el === 'm.o') { path_lyr_mo = find_lyr_in(escs, st.png); stats.arr_mo = promedios(st);               }
        else if (ES_NITRO    ) { path_lyr_n  = find_lyr_in(escs, st.png); stats.arr_n  = promedios(st);               }
        else if (el === 'no3') { path_lyr_n  = find_lyr_in(escs, st.png); stats.arr_n  = promedios(st).map(NO3_to_N); }
        else if (el === 'p'  ) { path_lyr_p  = find_lyr_in(escs, st.png); stats.arr_p  = promedios(st);               }
        else if (el === 'k'  ) { path_lyr_k  = find_lyr_in(escs, st.png); stats.arr_k  = promedios(st);               }
        else if (el === 's'  ) { path_lyr_s  = find_lyr_in(escs, st.png); stats.arr_s  = promedios(st);               }
        else if (el === 'b'  ) { path_lyr_b  = find_lyr_in(escs, st.png); stats.arr_b  = promedios(st);               }
        else if (el === 'ca' ) { path_lyr_ca = find_lyr_in(escs, st.png); stats.arr_ca = promedios(st);               }
        else if (el === 'mg' ) { path_lyr_mg = find_lyr_in(escs, st.png); stats.arr_mg = promedios(st);               }
        else if (el === 'zn' ) { path_lyr_zn = find_lyr_in(escs, st.png); stats.arr_zn = promedios(st);               }

        if (ES_NITRO) {
          this.n_is_mineral = (
            takeFilename(path_lyr_n).toLowerCase().indexOf('min') !== -1 ||
            st.tif.toLowerCase().indexOf('min')                   !== -1 ||
            st.png.toLowerCase().indexOf('min')                   !== -1
          );
        }
      }


      fetch_unit_inv_lyr(app, path_lyr_mo, (res_mo) => {
        fetch_unit_inv_lyr(app, path_lyr_n, (res_n) => {
          fetch_unit_inv_lyr(app, path_lyr_p, (res_p) => {
            fetch_unit_inv_lyr(app, path_lyr_k, (res_k) => {
              fetch_unit_inv_lyr(app, path_lyr_s, (res_s) => {
                fetch_unit_inv_lyr(app, path_lyr_b , (res_b) => {
                  fetch_unit_inv_lyr(app, path_lyr_ca, (res_ca) => {
                    fetch_unit_inv_lyr(app, path_lyr_mg, (res_mg) => {
                      fetch_unit_inv_lyr(app, path_lyr_zn, (res_zn) => {
                        if (! _.has(res_mo, 'error')) { stats.unit_mo = remove_parens(res_mo.units); stats.inv_mo = res_mo.inverted; } else { stats.unit_mo = ''; stats.inv_mo = false;}
                        if (! _.has(res_n , 'error')) { stats.unit_n  = remove_parens(res_n.units );                                 } else { stats.unit_n  = '';                      }
                        if (! _.has(res_p , 'error')) { stats.unit_p  = remove_parens(res_p.units );                                 } else { stats.unit_p  = '';                      }
                        if (! _.has(res_k , 'error')) { stats.unit_k  = remove_parens(res_k.units );                                 } else { stats.unit_k  = '';                      }
                        if (! _.has(res_s , 'error')) { stats.unit_s  = remove_parens(res_s.units ); stats.inv_s  = res_s.inverted;  } else { stats.unit_s  = ''; stats.inv_s  = false;}
                        if (! _.has(res_b , 'error')) { stats.unit_b  = remove_parens(res_b.units ); stats.inv_b  = res_b.inverted;  } else { stats.unit_b  = ''; stats.inv_b  = false;}
                        if (! _.has(res_ca, 'error')) { stats.unit_ca = remove_parens(res_ca.units); stats.inv_ca = res_ca.inverted; } else { stats.unit_ca = ''; stats.inv_ca = false;}
                        if (! _.has(res_mg, 'error')) { stats.unit_mg = remove_parens(res_mg.units); stats.inv_mg = res_mg.inverted; } else { stats.unit_mg = ''; stats.inv_mg = false;}
                        if (! _.has(res_zn, 'error')) { stats.unit_zn = remove_parens(res_zn.units); stats.inv_zn = res_zn.inverted; } else { stats.unit_zn = ''; stats.inv_zn = false;}

                        this.setState({ stats });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    }
  }

  // Verifica si los inputs están con el formato correcto
  can_calculate = () => {
    if (typeof(this.state.rdto) !== 'number') return fail('rdto no es un número');
    if (this.state.rdto <= 0)                 return fail('rdto es cero');
    if (this.state.especie === '')            return fail('no es una especie');
    if (this.state.prof === -1)               return fail('profundidad de muestreo desconocida');
    if (this.state.stats.arr_ph.length === 0) return fail('arr_ph está vacío');
    if (this.state.stats.arr_mo.length === 0) return fail('arr_mo está vacío');
  };

  // Funcion que entrega los datos a exportar en un csv
  calcular_elementos = async () => {
    const { especie, especies_ids, prof, stats } = this.state;

    const selected_especie = _.find(especies_ids, esp => esp.ESPECIE === especie);

    if (this.can_calculate && !!stats) {
      const has_n  = stats.arr_n.length  > 0,
            has_p  = stats.arr_p.length  > 0,
            has_k  = stats.arr_k.length  > 0,
            has_s  = stats.arr_s.length  > 0,
            has_b  = stats.arr_b.length  > 0,
            has_ca = stats.arr_ca.length > 0,
            has_mg = stats.arr_mg.length > 0,
            has_zn = stats.arr_zn.length > 0;

      const elementos_predio = selected_especie.IDS.map((id, i) => {
        const ph   = stats.arr_ph[id],
              mo   = stats.arr_mo[id],
              DAP  = dap(mo),
              n    = has_n  ? convert_to_kgha(stats.arr_n[id],  prof, DAP, stats.unit_n)  : -1,
              p    = has_p  ? convert_to_kgha(stats.arr_p[id],  prof, DAP, stats.unit_p)  : -1,
              k    = has_k  ? convert_to_kgha(stats.arr_k[id],  prof, DAP, stats.unit_k)  : -1,
              s    = has_s  ? convert_to_kgha(stats.arr_s[id],  prof, DAP, stats.unit_s)  : -1,
              b    = has_b  ? convert_to_kgha(stats.arr_b[id],  prof, DAP, stats.unit_b)  : -1,
              ca   = has_ca ? convert_to_kgha(stats.arr_ca[id], prof, DAP, stats.unit_ca) : -1,
              mg   = has_mg ? convert_to_kgha(stats.arr_mg[id], prof, DAP, stats.unit_mg) : -1,
              zn   = has_zn ? convert_to_kgha(stats.arr_zn[id], prof, DAP, stats.unit_zn) : -1,
              hect = selected_especie.HECTAREAS[i];

        return { id, ph, mo, dap: DAP, n, p, k, s, b, ca, mg, zn, hect };
      });
      console.log(elementos_predio);

      this.setState({ 
        elementos: [{
          hect: _.sum(elementos_predio.map(e => e.hect)),
          prof: prof * 10,
          ph:   _.mean(elementos_predio.map(e => e.ph)),
          mo:   _.mean(elementos_predio.map(e => e.mo)),
          dap:  _.mean(elementos_predio.map(e => e.dap)),
          n:    _.mean(_.compact(elementos_predio.map(e => e.n  !== -1 ? e.n  : false))),
          p:    _.mean(_.compact(elementos_predio.map(e => e.p  !== -1 ? e.p  : false))),
          k:    _.mean(_.compact(elementos_predio.map(e => e.k  !== -1 ? e.k  : false))),
          s:    _.mean(_.compact(elementos_predio.map(e => e.s  !== -1 ? e.s  : false))),
          b:    _.mean(_.compact(elementos_predio.map(e => e.b  !== -1 ? e.b  : false))),
          ca:   _.mean(_.compact(elementos_predio.map(e => e.ca !== -1 ? e.ca : false))),
          mg:   _.mean(_.compact(elementos_predio.map(e => e.mg !== -1 ? e.mg : false))),
          zn:   _.mean(_.compact(elementos_predio.map(e => e.zn !== -1 ? e.zn : false)))
        }]
      });
    } else {
      this.setState({ elementos: [], requerimientos_elem: [] })
    }
  };

  // Funcion para seleccionar el cultivable (cuando hay más de uno seleccionado)
  select_culti = (culti_path) => {
    const { app } = this.props,
          { toolbar, map_ui } = this.props.app,
          toggle = document.getElementById('tableToggle');

    // Se esconde la tabla una vez que se cambia el cultivable
    toggle.classList.remove('opened');

    // Limpia los polígonos que se hayan creado
    if (this.state.pols.length !== 0) {
      this.destroy_pols(this.state.pols, () => {});
    }

    // Limpia los tags de los lotes
    if (map_ui.map.Shp_List[culti_path] !== null) {
      _.keys(map_ui.map.Shp_List).forEach(path => {
        if (path !== culti_path) {
          map_ui.map.Shp_List[path].un_labelize();
        } else {
          map_ui.map.Shp_List[path].labelize_cf(this.props.tag_hl);
        }
      });
    }

    get_ms_of_dir(app, takeDir(culti_path), result => {
      // Primero carga los datos del nuevo cultivable seleccionado
      load_stats(app, culti_path, false, false, !app.agrosat_user, ss => {
        const preamble = (fun = noop) => {
          fun(true);
        };

        preamble(result => {
          if (toolbar !== null) {
            toolbar.all_stats = ss;
          }
        });

        // Luego se cargan las escalas como en componentDidMount
        preload_escalas(app, takeDir(culti_path), escs => {
          let prof = -1,
              prof_known = false;

          if (typeof(result) !== 'string') {
            const shp = result,
                  profs = _.uniq(_.map(shp.dbfRecords, 'PROF'));

            if (profs.length > 0 && typeof(profs[0]) === 'number') {
              prof = conv_to_decimeters(profs[0]);
              prof_known = true;
            } else {
              prof = conv_to_decimeters(30);
              prof_known = true;
            }
          }

          this.setState({ prof, prof_known }, () => { this.read_stats(app, escs) });
        });
      });
    });

    this.get_especies(especies_db => {
      // Especies de los predios en el cultivable seleccionado
      const especies_path = _.uniq(
        _.chain(
          _.compact(map_ui.map.Shp_List[culti_path].obj.dbfRecords.map(esp => {
            return _.has(esp, 'ESPECIE') && esp.ESPECIE !== 'NULL' ? esp.ESPECIE : null;
          })).map(e => e.toLowerCase())
        ).split(',').value()
      ),
      especies_filter = _.uniq(_.compact(especies_db.map(esp => esp.especie))),
      especies_filter_alt = _.uniq(_.compact(especies_db.map(esp => _.compact(_.split(esp.especie_alt, ','))))),
      especies = _.chain(especies_filter).concat(_.flatten(especies_filter_alt)).interseccion(especies_path).value().sort();

      const especies_nm = especies.map(esp => especies_db.find(obj => obj.especie_alt.includes(esp)));

      this.setState({ especies, especies_nm }, () => {
        const { especies } = this.state;

        const especies_ids = especies.map(esp => {
          let ids_especie = {
            ESPECIE: esp,
            HECTAREAS: [],
            IDS: [],
            NOMBRE: []
          };

          for (const r of map_ui.map.Shp_List[culti_path].obj.dbfRecords) {
            if (_.includes(r.ESPECIE.toLowerCase(), esp)) {
              ids_especie.HECTAREAS.push(typeof(r.HECTAREAS) !== 'number' ? parseFloat(r.HECTAREAS) : r.HECTAREAS);
              ids_especie.IDS.push(r.ID - 1);
              ids_especie.NOMBRE.push(typeof(r.NOMBRE) !== 'string' ? (r.NOMBRE) : r.NOMBRE)
            }
          }

          return ids_especie;
        });

        this.setState({ especies_ids });
      });
    });

    this.setState({
      culti: culti_path,
      elementos: [],
      especie: '',
      especie_data: {
        dem_min_n:      0,
        dem_max_n:      0,
        dem_min_p2o5:   0,
        dem_max_p2o5:   0,
        dem_min_k2o:    0,
        dem_max_k2o:    0,
        dem_min_so3:    0,
        dem_max_so3:    0,
        dem_min_b:      0,
        dem_max_b:      0,
        dem_min_cao:    0,
        dem_max_cao:    0,
        dem_min_mgo:    0,
        dem_max_mgo:    0,
        dem_min_zn:     0,
        dem_max_zn:     0,
        rdto_min:       0,
        rdto_max:       0,
        rin:            0,
        rip:            0,
        rik:            0,
        ri_s:           0,
        ri_b:           0,
        ri_ca:          0,
        ri_mg:          0,
        ri_zn:          0,
        u_rdto:        ''
      },
      show_table: false,
      pols: [],
      rdto: 0,
      rdto_inrange: false
    });
  };

  // Funcion para seleccionar la especie de la lista disponible
  select_especie = (especie) => {
    const toggle = document.getElementById('tableToggle');

    // Se esconde la tabla cuando se cambia el cultivo
    toggle.classList.remove('opened');

    // Se obtiene la información completa de la especie seleccionadda
    this.get_especie(especie, especie_db => {
      this.setState({
        elementos: [],
        especie: especie,
        especie_data: {
          dem_min_n:    especie_db[0].dem_min_n    !== null ? especie_db[0].dem_min_n    :  0,
          dem_max_n:    especie_db[0].dem_max_n    !== null ? especie_db[0].dem_max_n    :  0,
          dem_min_p2o5: especie_db[0].dem_min_p2o5 !== null ? especie_db[0].dem_min_p2o5 :  0,
          dem_max_p2o5: especie_db[0].dem_max_p2o5 !== null ? especie_db[0].dem_max_p2o5 :  0,
          dem_min_k2o:  especie_db[0].dem_min_k2o  !== null ? especie_db[0].dem_min_k2o  :  0,
          dem_max_k2o:  especie_db[0].dem_max_k2o  !== null ? especie_db[0].dem_max_k2o  :  0,
          dem_min_so3:  especie_db[0].dem_min_so3  !== null ? especie_db[0].dem_min_so3  :  0,
          dem_max_so3:  especie_db[0].dem_max_so3  !== null ? especie_db[0].dem_max_so3  :  0,
          dem_min_b:    especie_db[0].dem_min_b    !== null ? especie_db[0].dem_min_b    :  0,
          dem_max_b:    especie_db[0].dem_max_b    !== null ? especie_db[0].dem_max_b    :  0,
          dem_min_cao:  especie_db[0].dem_min_cao  !== null ? especie_db[0].dem_min_cao  :  0,
          dem_max_cao:  especie_db[0].dem_max_cao  !== null ? especie_db[0].dem_max_cao  :  0,
          dem_min_mgo:  especie_db[0].dem_min_mgo  !== null ? especie_db[0].dem_min_mgo  :  0,
          dem_max_mgo:  especie_db[0].dem_max_mgo  !== null ? especie_db[0].dem_max_mgo  :  0,
          dem_min_zn:   especie_db[0].dem_min_zn   !== null ? especie_db[0].dem_min_zn   :  0,
          dem_max_zn:   especie_db[0].dem_max_zn   !== null ? especie_db[0].dem_max_zn   :  0,
          rdto_min:     especie_db[0].rdto_min     !== null ? especie_db[0].rdto_min     :  0,
          rdto_max:     especie_db[0].rdto_max     !== null ? especie_db[0].rdto_max     :  0,
          rin:          especie_db[0].rin          !== null ? especie_db[0].rin          :  0,
          rip:          especie_db[0].rip          !== null ? especie_db[0].rip          :  0,
          rik:          especie_db[0].rik          !== null ? especie_db[0].rik          :  0,
          ri_s:         especie_db[0].ri_s         !== null ? especie_db[0].ri_s         :  0,
          ri_b:         especie_db[0].ri_b         !== null ? especie_db[0].ri_b         :  0,
          ri_ca:        especie_db[0].ri_ca        !== null ? especie_db[0].ri_ca        :  0,
          ri_mg:        especie_db[0].ri_mg        !== null ? especie_db[0].ri_mg        :  0,
          ri_zn:        especie_db[0].ri_zn        !== null ? especie_db[0].ri_zn        :  0,
          u_rdto:       especie_db[0].u_rdto        !== null ? especie_db[0].u_rdto      : ''
        },
        rdto: especie_db[0].rdto_min !== null ? especie_db[0].rdto_min : 0,
        rdto_inrange: true,
        show_table: false
      }, () => {
        if (this.state.pols.length !== 0) {
          // Si hay polígonos de color creados, primero se destruyen y luego se crean los correspondientes a la especie
          const { app } = this.props,
                { culti, especie, especies_ids, pols } = this.state;

          this.destroy_pols(pols, () => {
            get_culti_of_dir(app, takeDir(culti), result => {
              const { map_ui } = this.props.app,
                    { google, vec2LL } = Map,
                    shape = result,
                    opt = _.clone(Shp.polygonOptions_CF),
                    good_dbf = _.has(shape, 'dbfRecords') && shape.dbfRecords.length > 0;

              let pols = [];

              for (const esp_ids of especies_ids) {
                if (esp_ids.ESPECIE === especie) {
                  for (const i of esp_ids.IDS) {
                    let pol = new google.Polygon(opt);

                    let shp = shape.shapes[i];

                    pol.setPaths(_.map(shp.rings, ring => _.map(ring, vec2LL)));
                    pol.setMap(map_ui.map.map);
                    pol.setOptions({ fillColor: '#696A6C' });

                    if (good_dbf && _.has(shape.dbfRecords[i], 'AREA')) {
                      pol.AREA = shape.dbfRecords[i].AREA;
                    }

                    pol.HECTAREAS = good_dbf ? shape.dbfRecords[i].HECTAREAS : 0;
                    pol.ID = i;

                    pols.push(pol);
                  }
                }
              }

              this.setState({ pols });
            });
          });
        } else {
          const { app } = this.props,
                { culti, especie, especies_ids } = this.state;

          get_culti_of_dir(app, takeDir(culti), result => {
            const { map_ui } = this.props.app,
                  { google, vec2LL } = Map,
                  shape = result,
                  opt = _.clone(Shp.polygonOptions_CF),
                  good_dbf = _.has(shape, 'dbfRecords') && shape.dbfRecords.length > 0;

            let pols = [];

            for (const esp_ids of especies_ids) {
              if (esp_ids.ESPECIE === especie) {
                for (const i of esp_ids.IDS) {
                  let pol = new google.Polygon(opt);

                  let shp = shape.shapes[i];

                  pol.setPaths(_.map(shp.rings, ring => _.map(ring, vec2LL)));
                  pol.setMap(map_ui.map.map);
                  pol.setOptions({ fillColor: '#696A6C' });

                  if (good_dbf && _.has(shape.dbfRecords[i], 'AREA')) {
                    pol.AREA = shape.dbfRecords[i].AREA;
                  }

                  pol.HECTAREAS = good_dbf ? shape.dbfRecords[i].HECTAREAS : 0;
                  pol.ID = i;

                  pols.push(pol);
                }
              }
            }

            this.setState({ pols });
          });
        }
      });
    });
  };

  // Funcion para cambiar el valor del rendimiento esperado
  rdto_change = (ev) => {
    const { rdto_min, rdto_max } = this.state.especie_data,
          rdto = parseInt(ev.target.value, 10);

    this.setState({ rdto, rdto_inrange: in_range(rdto, rdto_min, rdto_max) });
  }; 

  // Función que muestra la tabla con los cálculos de inputs
  ingresar = () => {
    const { app } = this.props,
          { especie, rdto } = this.state,
          warn_especie = (<li>Debe elegir una especie.</li>),
          warn_rdto    = (<li>Debe elegir un rendimiento esperado</li>),
          toggle       = document.getElementById('tableToggle');

    if (especie !== '' && (rdto !== 0 && !isNaN(rdto))) {
      toggle.classList.add('opened');

      this.setState({
        show_table: true
      }, async () => {
        // Las funciones de calculo van acá
        await this.calcular_elementos();
      });
    } else {
      app.setState({
        custom_warning: (
          <center>
            <img src="./img/warning.png" alt="warning_sign" style={{ paddingBottom: '30px' }}/>
            <ul style={{ textAlign: 'left' }}>
              {especie === '' && warn_especie}
              {(rdto   ===  0 || isNaN(rdto)) && warn_rdto}
            </ul>
          </center>
        )
      });
    }
  };

  // Funcion para exportar los datos a un csv
  exportar = () => {
    console.log('Exportar!');
  }

  // Se define el <div> para la selección de cutivables activados
  render_culti = () => {
    const content_culti = (
      <span className="empty-select" style={{ color: 'lightgrey' }}>
        <b>{abrev(title_culti(this.state.culti, 30))}</b>
      </span>
    );

    const content_cultis = (
      <select className="custom-select" style={{ padding: '.6em 1.4em .5em 0.6em' }} defaultValue={this.state.culti} onChange={ev => this.select_culti(ev.target.value)}>
        {this.state.cultis.map((path, id) => 
          <option value={path} key={id} selected={path === this.state.culti}>
            <b>{abrev(title_culti(path), 30)}</b>
          </option>
        )}
      </select>
    );

    return (
      <div style={{ display: 'flex', height: '50px', padding: '5px 0px' }}>
        <img src={iconCulti} alt="icon_culti" style={{ height: '40px', padding: '5px 8px 5px 18px' }} />
        {this.state.cultis.length !== 1 ? content_cultis : content_culti}
      </div>
    );
  };

  // Se define el <div> para la selección de especie
  render_especies = () => {
    const content_especie = (
      <select className="custom-select" defaultValue="" onChange={ev => this.select_especie(ev.target.value)}>
        <option value="" selected={this.state.especie === ''} disabled>Especie</option>
        {this.state.especies.map((especie, id) => 
          <option value={especie} key={id}>{this.state.especies_nm[id].especie}</option>
        )}
      </select>
    );

    const content_especie_empty = (
      <span className="empty-select">
        <b>No se detectan especies.</b>
      </span>
    );

    return (
      <div style={{ display: 'flex', height: '45px', padding: '5px 0px' }}>
        <img src={iconEspecie} alt="icon_especie" style={{ height: '40px', padding: '5px 10px 5px 18px' }}/>
        {this.state.especies.length !== 0 ? content_especie : content_especie_empty}
      </div>
    );
  };

  // Se define el <div> para la selección de rendimiento esperado
  render_rdto = () => {
    const content_title = (
      <div style={{ display: 'flex', padding: '5px 0px' }}>
        <img src={iconRdto} alt="icon_rdto" style={{ height: '40px', padding: '0px 5px 0px 15px' }}/>
        <span className="empty-select" style={{ paddingRight: '2.1em' }}>Rendimiento Esperado</span>
      </div>
    );

    const content_rdto = (
      <div className="content-rdto">
        <input className="input-rdto" type="number" disabled={this.state.especie === ''} value={this.state.rdto} onChange={this.rdto_change} style={{ border: `1px solid ${this.state.rdto_inrange ? 'gray' : 'red'}` }}/>
        &nbsp;&nbsp;{this.state.especie_data.u_rdto ? this.state.especie_data.u_rdto : '-- / --'}
        <p style={{ margin: '10px 0px' }}>
          <span key={0}>Mínimo: {snum(this.state.especie_data.rdto_min, 0)} / Máximo: {snum(this.state.especie_data.rdto_max, 0)}</span>
        </p>
        <p style={{ margin: '10px 0px 0px 0px' }}>
          <span key={1} style={{ wordWrap: 'break-word' }}><i>Valores de referencia, su rendimiento esperado puede superar estos umbrales.</i></span>
        </p>
      </div>
    );

    return (
      <div style={{ padding: '5px 0px' }}>
        {content_title}
        {content_rdto}
      </div>
    );
  };

  // Se define el <div> con la tabla de los elementos que se van a exportar
  render_tabla = () => {
    const { elementos, especie, prof } = this.state;

    return (
      <div className="result-table" style={{ display: 'block', padding: '0px' }}>
        <table className="Table">
          <thead>
            <tr>
              <th className="TableTitle" colSpan="5">PROPIEDADES QUÍMICAS Y FÍSICAS</th>
            </tr>
            <tr>
              <th>Hect (Ha)</th>
              <th>Prof (cm)</th>
              <th>pH</th>
              <th>M.O. (%)</th>
              <th>DAP (g/cm<sup>3</sup>)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{snum(elementos[0].hect, 2)}</td>
              <td>{snum(elementos[0].prof , 0)}</td>
              <td>{snum(elementos[0].ph, 2)}</td>
              <td>{snum(elementos[0].mo, 2)}</td>
              <td>{snum(elementos[0].dap, 2)}</td>
            </tr>
          </tbody>
        </table>
        <table className="Table">
          <thead>
            <tr>
              <th className="TableTitle" colSpan="8">CONENCTRACÍON DE ELEMENTOS QUÍMICOS (Kg/Ha)</th>
            </tr>
            <tr>
              <th>N</th>
              <th>P</th>
              <th>K</th>
              <th>S</th>
              <th>B</th>
              <th>Ca</th>
              <th>Mg</th>
              <th>Zn</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{snum(elementos[0].n, 2)}</td>
              <td>{snum(elementos[0].p, 2)}</td>
              <td>{snum(elementos[0].k, 2)}</td>
              <td>{snum(elementos[0].s, 2)}</td>
              <td>{snum(elementos[0].b, 2)}</td>
              <td>{snum(elementos[0].ca, 2)}</td>
              <td>{snum(elementos[0].mg, 2)}</td>
              <td>{snum(elementos[0].zn, 2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    const { app } = this.props;

    return (
      <div style={{ display: 'flex', height: '50px', padding: '5px 0px' }}>
        <XDialog name="show_central_fert" title="CENTRAL DE FERTILIZACIÓN" father={app} drag={true} no_close={false} font={app.favorite_font()} huge_title={true}>
          <div className="CentralFert">
            {this.render_culti()}
            {this.render_especies()}
            {this.render_rdto()}
            <div id="tableToggle" className="CentralFertResult">
              {this.state.elementos.length > 0 && this.render_tabla()}
            </div>
            <div className="ingresar-btn">
              {this.state.elementos.length > 0 ?
                <CSVLink className="btn" data={this.state.elementos} filename={'datos_central_fert.csv'}>EXPORTAR</CSVLink>
                :
                <button className="btn" type="button" onClick={this.ingresar}>INGRESAR</button>
              }
            </div>
          </div>
        </XDialog>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/CentralFert.jsx